import { Grid, Group, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { cleanNotifications, showNotification } from "@mantine/notifications";
import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AdminInputField from "../../components/adminInputField";
import AdminPage from "../../components/AdminPage";
import Button from "../../components/Button";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import PasswordField from "../../components/PasswordField";
import {
  emailRegex,
  nameRegex,
  passwordRegex,
  userNameRegex,
} from "../../constants/index";
import { axiosPost } from "../../Helpers";
import { addAndEditData } from "../generalPostAndEditData";
import { loadProfileInfo } from "./loadData";

const AddUsers = () => {
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      userName: "",
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      cpassword: "",
    },

    validate: {
      userName: (value) =>
        value?.trim()?.length > 1 && userNameRegex.test(value.trim())
          ? null
          : "Alphabetic Numeric UserName without Spaces",
      firstName: (value) =>
        value?.trim()?.length > 1 && nameRegex.test(value.trim())
          ? null
          : "Alphabetic Last Name with 2 or more characters",
      lastName: (value) =>
        value?.trim()?.length > 1 && nameRegex.test(value.trim())
          ? null
          : "Alphabetic First Name with 2 or more characters",
      email: (value) =>
        emailRegex.test(value?.trim()) ? null : "Invalid Email",
      password: (value) =>
        passwordRegex.test(value)
          ? null
          : "Must Contain 8 Characters, 1 Uppercase, 1 Lowercase, 1 Number, 1 Special Character",
      cpassword: (value, values) =>
        value === values.password ? null : "Passwords do not match",
    },
  });
  const [update, setUpdate] = useState(false);
  const [opened, setOpened] = useState(true);
  let location = useLocation();
  let navigate = useNavigate();
  const [userData, setUserData] = useState({});
  console.log("editData in add modal", userData);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    loadProfileInfo(setLoading).then(setUserData);
  }, [location.pathname, update]);
  useEffect(() => {
    if (userData !== null) {
      form.setValues({
        role: userData.role,
        userName: userData.userName,
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        password: "@Admin123",
        cpassword: "@Admin123",
      });
    }
  }, [userData, loading]);

  let userId = userData._id;
  const onSubmit = async (values) => {
    values.userId = userId;
    let url = `user/editUser`;
    setLoading(true);
    console.log("values", values);

    setOpened(false);
    cleanNotifications();
    console.log(values, "this is the values and url");

    axiosPost(url, values).then((response) => {
      console.log("Posted", url, response.data);
      if (!response.data.status) {
        showNotification({
          title: "Error",
          message: `${response.data.message}`,
          color: "red",
        });
        setLoading(false);
      } else {
        setUpdate((prev) => !prev);
        setOpened(false);
        showNotification({
          title: "Success",
          message: `${response.data.message}`,
          color: "green",
        });
        setLoading(false);
      }
    });
  };

  const InternalContent = (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Grid justify="center">
        <Grid.Col md={6}>
          <Text mb={0} weight={500}>
            First Name
          </Text>
          <AdminInputField
            width="100%"
            placeholder="Enter First Name"
            form={form}
            validateName="firstName"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <Text mb={0} weight={500}>
            Last Name
          </Text>
          <AdminInputField
            width="100%"
            placeholder="Enter Last Name"
            form={form}
            validateName="lastName"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <Text mb={0} weight={500}>
            User Name
          </Text>
          <AdminInputField
            // label={"User Name"}
            width="100%"
            placeholder="Enter User Name"
            form={form}
            validateName="userName"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <Text mb={0} weight={500}>
            Email
          </Text>
          <AdminInputField
            width="100%"
            placeholder="Enter User Name"
            form={form}
            validateName="email"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <Text mb={0} weight={500}>
            Password
          </Text>
          <PasswordField
            width="100%"
            placeholder="Enter Password"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            onInput={(e) => {
              if (e.target.value !== form.values.cpassword) {
                form.setFieldError("cpassword", "Passwords Do Not Match");
              } else {
                form.setFieldError("cpassword", "");
              }
            }}
            form={form}
            validateName="password"
          />
        </Grid.Col>
        <Grid.Col md={6}>
          <Text mb={0} weight={500}>
            Confirm Password
          </Text>
          <PasswordField
            width="100%"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            placeholder="Re-Enter Password"
            errorProps={(v) => {
              return v !== form.values.password;
            }}
            form={form}
            validateName="cpassword"
          />
        </Grid.Col>
      </Grid>

      <Group position="right" pt="xl">
        <Button
          title={"Cancel"}
          fontWeight="700"
          onClick={() => {
            navigate("/admin/users");
          }}
        />
        <Button title={"Save"} primary={true} fontWeight="700" type="submit" />
      </Group>
    </form>
  );

  return (
    <LoaderWrapper loading={loading}>
      <AdminPage title={"Edit My Profile"}>{InternalContent}</AdminPage>
    </LoaderWrapper>
  );
};

export default AddUsers;
